import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

export function ConfirmDialog({
  open,
  onOpenChange,
  title,
  message,
  details,
  onConfirm,
  onCancel,
  confirmText = "Yes",
  cancelText = "No",
  confirmVariant = "destructive"
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4">
          <p className="text-sm text-gray-600">
            {message}
          </p>
          
          {details && (
            <div className="bg-gray-50 p-4 rounded-lg">
              {typeof details === 'string' ? (
                <p className="text-sm font-semibold">{details}</p>
              ) : (
                details
              )}
            </div>
          )}

          <div className="flex gap-4">
            <Button 
              type="button" 
              variant="outline" 
              onClick={onCancel} 
              className="flex-1"
            >
              {cancelText}
            </Button>
            <Button 
              type="button" 
              onClick={onConfirm} 
              variant={confirmVariant}
              className="flex-1"
            >
              {confirmText}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
